import { fundingReference } from './merchantFundingReceipt';

const revision = (value) =>
  Number.isSafeInteger(value) && value >= 0 && value < Number.MAX_SAFE_INTEGER;
const date = (value) =>
  typeof value === 'string' &&
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value) &&
  Number.isFinite(Date.parse(value)) &&
  new Date(value).toISOString() === value;

/** Private admin evidence; never attach this to a distributor purchase receipt. */
export function readMerchantAdverseReview(response, purchase) {
  const value = response?.data?.data;
  if (
    !value ||
    value.purchaseId !== purchase._id ||
    value.method !== purchase.method ||
    !['ach', 'card'].includes(value.method) ||
    value.amountCents !== purchase.amountCents ||
    !Number.isSafeInteger(value.amountCents) ||
    value.amountCents < 1 ||
    value.amountCents > 9999999 ||
    value.currency !== 'USD' ||
    !revision(value.expectedAttemptRevision) ||
    typeof value.transactionId !== 'string' ||
    !/^[A-Za-z0-9._:-]{1,200}$/.test(value.transactionId) ||
    typeof value.realmId !== 'string' ||
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,199}$/.test(value.realmId) ||
    typeof value.canReview !== 'boolean'
  )
    throw new Error('Invalid merchant review');
  const evidence = value.merchantAdverseReview;
  if (
    evidence !== null &&
    (!evidence ||
      evidence.version !== 1 ||
      evidence.source !== 'quickbooks_merchant_service_center' ||
      evidence.status !== 'no_adverse_items_observed' ||
      typeof evidence.requestKey !== 'string' ||
      !/^[A-Za-z0-9_-]{16,100}$/.test(evidence.requestKey) ||
      !revision(evidence.expectedAttemptRevision) ||
      evidence.expectedAttemptRevision > value.expectedAttemptRevision ||
      typeof evidence.reviewedBy !== 'string' ||
      !/^[a-f\d]{24}$/i.test(evidence.reviewedBy) ||
      !date(evidence.reviewedAt) ||
      evidence.realmId !== value.realmId ||
      evidence.transactionId !== value.transactionId ||
      evidence.amountCents !== value.amountCents ||
      evidence.currency !== value.currency ||
      typeof evidence.intentHash !== 'string' ||
      !/^[a-f\d]{64}$/.test(evidence.intentHash) ||
      !fundingReference(evidence.reviewReference))
  )
    throw new Error('Invalid merchant review evidence');
  return value;
}

export function matchesAdverseReviewIntent(value, intent, actorId) {
  return Boolean(
    value.merchantAdverseReview &&
      !value.canReview &&
      value.expectedAttemptRevision > intent.expectedAttemptRevision &&
      value.merchantAdverseReview.reviewedBy === actorId &&
      [
        'requestKey',
        'expectedAttemptRevision',
        'realmId',
        'transactionId',
        'amountCents',
        'currency',
        'reviewReference',
      ].every((key) => value.merchantAdverseReview[key] === intent[key])
  );
}
